/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
import { prepScopes } from '../../utils/GraphHelpers';
import { GraphPageIterator } from '../../utils/GraphPageIterator';
/**
 * returns Calender events iterator associated with either the logged in user or a specific groupId
 *
 * @param {Date} startDateTime
 * @param {Date} endDateTime
 * @param {string} [groupId]
 * @returns {(Promise<Event[]>)}
 * @memberof Graph
 */
export function getEventsPageIterator(graph, startDateTime, endDateTime, groupId) {
    const scopes = 'calendars.read';
    const sdt = `startdatetime=${startDateTime.toISOString()}`;
    const edt = `enddatetime=${endDateTime.toISOString()}`;
    let uri;
    if (groupId) {
        uri = `groups/${groupId}/calendar`;
    }
    else {
        uri = 'me';
    }
    uri += `/calendarview?${sdt}&${edt}`;
    const request = graph
        .api(uri)
        .middlewareOptions(prepScopes(scopes))
        .orderby('start/dateTime');
    return GraphPageIterator.create(graph, request);
}
//# sourceMappingURL=mgt-agenda.graph.js.map